import axiosInstance from "./service-instance";
import QueryString from "query-string";
import Endpoint from "constants/endpoint";
import {ONBOARDING_STAGES} from 'constants/enums';

export default {
    fetchCasesListAPI: (stage, page, page_size, type, filters)  =>  {
        const stage_id = ONBOARDING_STAGES.get(stage);
        return  axiosInstance.get(`${Endpoint.onboardingCasesList}?${QueryString.stringify({...filters})}`, {
            params: {
                stage: stage_id,
                page,
                page_size,
                type,
                show_my_cases: false,
                source : "soul"
            }
        })},
    fetchCasesDetailAPI: (id)  =>  {
        return  axiosInstance.get(Endpoint.onboardingCasesList, {
            params: {
                id,
                source : "soul"
            }
        })},

    fetchCasePendency: (actionDetailId) => axiosInstance.get(Endpoint.onboardingCasePendence.replace(':actionDetailId', actionDetailId)),
    fetchCompanyBackgroundAPI: ({company_id, mpa_approval_id}) => {
        return(
        axiosInstance.get(Endpoint.companyBackground, {
        params: {
            company_id,
            mpa_approval_id,
            source : "soul"
            },
        })
    )},
    fetchDeviationMatrixApi: ({ mpa_approval_id, download }) => {
        return(
        axiosInstance.get(Endpoint.deviationMatrix, {
        params: {
            mpa_approval_id,
            download,
            source : "soul"
            },
        })
    )},
    postCompanyBackgroundApi: (type, currentMpaId, formData) => {
        const method = type;
        let url = Endpoint.companyBackground;
        if (method === 'patch') {
            url = `${url}${currentMpaId}/`;
        }
        return axiosInstance[method](url, formData, {
            headers: {
                "Content-Type": "application/json",
            },
        });}
};